import React, { useState, useEffect } from "react";
import { initializeMessaging } from "./firebase";
import Search from "./Search";

import "./App.css";

function App() {
  const [isLoading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState("");
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");

  const apiURL =
    "https://services7.arcgis.com/mOBPykOjAyBO2ZKk/arcgis/rest/services/RKI_Landkreisdaten/FeatureServer/0/query?where=1%3D1&outFields=GEN,BEZ,cases,last_update,cases7_per_100k,AdmUnitId,cases_per_100k&outSR=4326&f=json";

  useEffect(() => {
    if ("caches" in window) {
      return getDataFromCache();
    } else {
      return getDataFromNetwork();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDataFromNetwork = () => {
    console.log("Fetching data over network...");
    return fetch(apiURL)
      .then((response) => response.json())
      .then(
        (result) => {
          const upToDate = compareDateWithToday(
            result.features[0].attributes.last_update
          );
          if (upToDate) {
            console.log("RKI data is up to date. Process network data.");
            processData(result);
            setLoading(false);
          } else {
            console.log("RKI data is not up to date. Keep cache data.");
          }
        },
        (error) => {
          console.error(error);
        }
      )
      .finally(() => setLoading(false));
  };

  const getDataFromCache = () => {
    caches
      .match(apiURL)
      .then((response) => {
        if (!response) throw Error("No data");
        return response.json();
      })
      .then((result) => {
        const upToDate = compareDateWithToday(
          result.features[0].attributes.last_update
        );
        processData(result);
        setLoading(false);
        console.log("Got data from cache!");
        if (!upToDate) {
          console.log("Cache data is outdated.");
          getDataFromNetwork();
        }
      })
      .catch(() => {
        console.log("Didn't get cached data, fetching over network.");
        return getDataFromNetwork();
      })
      .catch((error) => console.error("Error:", error));
  };

  const processData = (data) => {
    const coronaData = [];
    data.features.forEach((element) => {
      coronaData.push({
        id: element.attributes.AdmUnitId,
        name: element.attributes.BEZ + ": " + element.attributes.GEN,
        deaths: element.attributes.deaths,
        cases: element.attributes.cases,
        casesPerResidents:
          Math.round(element.attributes.cases_per_100k * 100) / 100,
        incidence: Math.round(element.attributes.cases7_per_100k * 100) / 100,
      });
    });
    setData(coronaData);
    setLastUpdated(data.features[0].attributes.last_update);
    setLoading(false);
  };

  const compareDateWithToday = (date) => {
    const today = getComparableDateStr(new Date().toLocaleDateString("de-DE"));
    const updatedByRKI = getComparableDateStr(date.split(",")[0]);

    if (today === updatedByRKI) {
      return true;
    } else {
      return false;
    }
  };

  const getComparableDateStr = (date) => {
    return date
      .split(".")
      .map((d) => parseInt(d, 10))
      .join(".");
  };

  const subscribePushNotifications = () => {
    if ('PushManager' in window) {
      const messaging = initializeMessaging();
      Notification.requestPermission().then(async () => {
        const token = await messaging.getToken(); 
        return token;
      }).then(token => {
        console.log("Your token is:", token);
        alert(`Bitte verifizieren Sie ihr Abonnement, indem Sie sich mit folgendem Schlüssel an den Betreiber der Seite wenden: ${token}`);
      }).catch(error => {
        console.log("No token found.", error);
        alert("Das hat nicht funktionert. Bitte stellen Sie sicher, dass Sie die Anwendung installiert haben und versuchen Sie es erneut.");
      })
    } else {
      alert("Dein Browser unterstützt keine Benachrichtigungen.");
    }
  };

  const filteredDistricts = data.filter((district) =>
    district.name.toLowerCase().includes(query.trim().toLowerCase())
  );

  return (
    <section className="main-container">
      <h1>Corona Daten nach deutschen Landkreisen</h1>
      <Search onQueryChange={setQuery} query={query} />
      <button onClick={subscribePushNotifications}>Benachrichtigungen abonnieren</button>
      {isLoading ? (
        <p>Die Daten werden geladen...</p>
      ) : (
        <>
          {!filteredDistricts[0] ? (
            <p>Es sind keine Daten zwischengespeichert, bitte verbinden sie das Gerät mit dem Internet.</p>
          ) : (
            <div className="district-list-container">
              <small>Zuletzt vom RKI aktualisiert am {lastUpdated}</small>
              <ul className="district-list">
                {filteredDistricts.map((district) => (
                  <li key={`district-${district.id}`}>
                    <h3>{district.name}</h3>
                    <p>Anzahl der Fälle: {district.cases}</p>
                    <p>
                      Fallzahl pro 100.000 Einwohner:{" "}
                      {district.casesPerResidents}
                    </p>
                    <p>
                      7-Tage Inzidenz pro 100.000 Einwohner:{" "}
                      {district.incidence}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}
    </section>
  );
}

export default App;
